import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getTenantPortalSession } from './tenantPortalSession';

/** Redirects to /admin if there is no tenant portal session (must match /admin login). */
export function useTenantPortalGuard() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!getTenantPortalSession()) {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);
}
